import {
  FETCH_SIMULATION_RESULTS,
  FETCH_SIMULATION_TABLE_INPUTS,
  FETCH_SIMULATION_TABLE_METADATA,
  FETCH_TOP_LINE_INPUT_DATA,
  GET_LIST_OF_SAVEDSCENARIO_NAMES,
  GET_SIMULATED_SUMMARY_TABLE_DATA,
  GET_SUMMARY_TABLE_DATA,
  RESET_PRICING_SUMMARY_TABLE_DATA,
  SAVE_SCEANRIO,
  SAVE_SUMMARY_TABLE_DATA,
  UPDATE_SCEANRIO
} from '../../../../../constants';
import { axios } from '../../../../../lib';
import {
  ISimulationResponse,
  ISimulationTableViewMetadata
} from '../types/simulation-view-table.model';

export function fetchSimulationTableInputs(body: {
  source_id: number;
  screen_id: number;
  filter_inputs: { field_name: string; field_values: any }[];
  simulation_id?: number;
}) {
  return axios
    .post<ISimulationResponse>(
      `${FETCH_SIMULATION_TABLE_INPUTS}${body.source_id}/`,
      body
    )
    .then((response) => response.data);
}

export function fetchSimulationTableMetadata(sourceId: number) {
  return axios
    .get<ISimulationTableViewMetadata>(
      `${FETCH_SIMULATION_TABLE_METADATA}${sourceId || 1}/`
    )
    .then((response) => response.data);
}

// Helper function to extract and sort child columns
function extractChildColumns(tempResponse: any) {
  return tempResponse.header
    .filter((tempData: any) => tempData.parent.alias === 'Sim Results') // Find the parent with alias 'Sim Results'
    .map((tempData: any) =>
      tempData.children && tempData.children.length > 0 ? tempData.children : []
    )
    .flat() // Flatten the child columns array dynamically
    .sort((a, b) => a.parent.order - b.parent.order); // Sort the child columns based on parent's order
}

export function simulatePricingSimulationData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${GET_SIMULATED_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => {
      
      const tempResponse = response.data;

      const tempCopyResponse = { ...response.data };

      const childColumns = extractChildColumns(tempResponse);

      tempCopyResponse.header.forEach((item) => {
        if (item.parent.alias === 'Sim Results') {
          item.parent.section = 'input';
          // item.children = []; 
        }
      });

      childColumns.forEach((item) => {
        tempCopyResponse.header.push(item);
      });

      return Promise.resolve(tempCopyResponse);
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      throw error;
    });
}

export function fetchPricingSimulationData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
): Promise<any> {

  return axios
    .post<any>(
      `${GET_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => {
      
      const tempResponse = response.data;

      const tempCopyResponse = { ...response.data };

      const childColumns = extractChildColumns(tempResponse);

      tempCopyResponse.header.forEach((item) => {
        if (item.parent.alias === 'Sim Results') {
          item.parent.section = 'input';
          // item.children = []; 
        }
      });

      childColumns.forEach((item) => {
        tempCopyResponse.header.push(item);
      });

      return Promise.resolve(tempCopyResponse);
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      throw error;
    });
}

export function resetSimulationData(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${RESET_PRICING_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      { filter_inputs: [] }
    )
    .then((response) => {
      
      const tempResponse = response.data;

      const tempCopyResponse = { ...response.data };

      const childColumns = extractChildColumns(tempResponse);

      tempCopyResponse.header.forEach((item) => {
        if (item.parent.alias === 'Sim Results') {
          item.parent.section = 'input';
          // item.children = []; 
        }
      });

      childColumns.forEach((item) => {
        tempCopyResponse.header.push(item);
      });

      return Promise.resolve(tempCopyResponse);
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      throw error;
    });
}

// Helper function to extract and sort child columns
function extractTopLineChildColumns(tempResponse: any) {
  return tempResponse.header
    .filter((tempData: any) => tempData.parent.alias.includes('Price Action')) // Find the Price Action parent columns
    .map((tempData: any) =>
      tempData.children && tempData.children.length > 0 ? tempData.children : []
    )
    .flat() // Flatten the child columns array dynamically
    .sort((a, b) => a.parent.order - b.parent.order); // Sort the child columns based on parent's order
}

export function fetchTopLineInputsData(
  sourceId: number,
  moduleId: number,
  scenarioId: number,
  filterInputs: any,
  toplineFields: any
) {
  return axios
    .post<any>(
      `${FETCH_TOP_LINE_INPUT_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      { filter_inputs: filterInputs, topline_fields: toplineFields }
    )
    .then((response) => {
      const tempResponse = response.data;

      const tempCopyResponse = { ...response.data };

      // Extract child columns (using the extractTopLineChildColumns function)
      const childColumns = extractTopLineChildColumns(tempResponse);


      // Add the child columns to the header
      childColumns.forEach((item) => {
        tempCopyResponse.header.push(item); // Append child columns to the header
      });

      return Promise.resolve(tempCopyResponse); // Return the modified response
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      throw error;
    });
}

export function saveSimulationData(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${SAVE_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      {}
    )
    .then((response) => response.data);
}

export function fetchPricingSimulationDataForSimulator(body: any) {
  return axios
    .post<any>(`${GET_SUMMARY_TABLE_DATA}1/3/1/`, body)
    .then((response) => response.data);
  // return Promise.resolve(GenericTableData);
}

export function fetchSimulationResults(body: {
  source_id: number;
  simulation_id: number;
  screen_id: number;
  filter_inputs: { field_name: string; field_values: any }[];
  data: { OWN: any[] };
}) {
  return axios
    .post<ISimulationResponse>(
      `${FETCH_SIMULATION_RESULTS}${body.source_id || 1}/`,
      body
    )
    .then((response) => response.data);
  // return Promise.resolve(SIMULATION_RESULS);
}

export function saveScenarioData(body: {
  source_id: number;
  simulation_id: number;
  name: string;
  description: string;
  price_action_at: any;
  is_active: boolean;
}) {
  return axios.patch(`${SAVE_SCEANRIO}${body.simulation_id}/`, body);
}

export function updateScenarioData(body: {
  source_id: number;
  simulation_id: number;
  name: string;
  description: string;
  price_action_at: any;
  is_active: boolean;
}) {
  return axios.patch(`${UPDATE_SCEANRIO}${body.simulation_id}/`, body);
}

export function getListOfScenarioNames(sourceId: number) {
  return axios.get(`${GET_LIST_OF_SAVEDSCENARIO_NAMES}${sourceId}/`);
}
